import { useCallback } from 'react'
import { useIntl } from 'react-intl'

import type { DetailItemCardVariant } from '../common/types'

import type { LEFlightItem } from 'tripPlanner/types/tripItem'
import { buildStandaloneFlightSearchURL } from 'tripPlanner/utils/bookmark/restoreCart'
import TextButton from 'LuxKit/Button/TextButton'
import useRestoreCart from 'tripPlanner/hooks/useRestoreCart'
import { tripSavedItemBookNowClicked } from 'analytics/eventDefinitions'
import { fireInteractionEvent } from 'api/googleTagManager'
import Group from 'components/utils/Group'

interface Props {
  item: LEFlightItem
  variant: DetailItemCardVariant
}

function FlightCTAContent({ item, variant }: Props) {
  const intl = useIntl()
  const flightSearchURL = buildStandaloneFlightSearchURL(
    item.savedItemData,
  )
  const { canRestoreCart, onClick } = useRestoreCart(item, flightSearchURL)

  const source =
    variant === 'drawer' ? 'trip_drawer_all_saved_items' : 'trip_summary'
  const onClickRestoreCartButton = useCallback<
    React.MouseEventHandler<HTMLButtonElement>
  >(
    (e) => {
      fireInteractionEvent(tripSavedItemBookNowClicked(source))
      onClick(e)
    },
    [source, onClick],
  )

  const showBookNowButton = canRestoreCart && variant === 'drawer'

  return (
    <Group
      direction="horizontal"
      verticalAlign="center"
      horizontalAlign="stretch"
      tabletHorizontalAlign="end"
      gap={12}
    >
      <TextButton
        kind={variant === 'drawer' && !showBookNowButton ? 'primary' : 'secondary'}
        to={flightSearchURL}
        target="_blank"
      >
        {intl.formatMessage({
          id: 'A0_56p-BTI3bEtFr0deu',
          defaultMessage: 'Search flights',
          description: 'Button to search for available flights for a flight trip item',
        })}
      </TextButton>
      {showBookNowButton && (
        <TextButton
          kind="primary"
          onClick={onClickRestoreCartButton}
        >
          {intl.formatMessage({
            id: 'B9LXdYsRb959680JT1QG',
            defaultMessage: 'Book now',
            description: 'Button to book a saved flight item from the detail card',
          })}
        </TextButton>
      )}
    </Group>
  )
}

export default FlightCTAContent
